import { defineStore } from "pinia";
import manageEventOrganizersApi, { EventOrganizer } from "../Api/manageEventOrganizers";
import { Bundle } from "../Common/consts";

export const useOrganizersStore = defineStore("organizers", {
    state() {
        return {
            eventId: 0,
            organizers: [] as EventOrganizer[],
        };
    },
    actions: {
        refreshOrganizersListing(): Promise<void> {
            return manageEventOrganizersApi.getListing(this.eventId).then(eventOrganizers => {
                this.organizers = eventOrganizers;
            });
        },
        updateOrganizer(eventUserId: number, role: string, bundles: Bundle[]): Promise<void> {
            return manageEventOrganizersApi
                .updateOrganizer(this.eventId, eventUserId, role, bundles)
                .then(() => this.refreshOrganizersListing());
        },
    },
});
